import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=2c5cee95"
import script from "./Billings.vue?vue&type=script&lang=js"
export * from "./Billings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports